import React from 'react'

import styles from "./linkFill.module.scss"

const LinkFill = props => {
  const { href, disabled } = props

  if (props.targetBlank) {
    return (
      <a
        className={styles.linkFill}
        href={href}
        disabled={disabled}
        target="_blank"
      >
        {props.children}
      </a>
    )
  } else {
    return (
      <a
        className={styles.linkFill}
        href={href}
        disabled={disabled}
      >
        {props.children}
      </a>
    )
  }
}

export default React.memo(LinkFill)